﻿import EventBoat from "@model/EventBoat"
import EventCategory from "@model/EventCategory"
import { Model } from "pinia-orm"
import { BelongsTo, Uid } from "pinia-orm/decorators"

export default class EventBoatCategory extends Model {
    static entity = 'events-boats-categories'

    @Uid() declare id: string
    @Uid() declare eventBoatId: string
    @BelongsTo( () => EventBoatCategory, 'eventBoatId' ) declare eventBoat: EventBoat
    @Uid() declare eventCategoryId: string
    @BelongsTo( () => EventCategory, 'eventCategoryId' ) declare eventCategory: EventCategory

    get dump () {
        return {
            category: this.eventCategoryId
        }
    }

    static piniaOptions = {
        persist: true
    }
}
